import { render, staticRenderFns } from "./ProjectGeneralPanel.vue?vue&type=template&id=2b8d41e6&"
import script from "./ProjectGeneralPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectGeneralPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports